import ajax from './ajax';

export interface MediaFile {
    mediaId: string;
    fileName: string;
    url: string;
    type: string;
    size: number;
    mimeType: string;
    uploadedAt: string;
}

export interface MediaUploadResponse {
    mediaId: string;
    url: string;
    fileName: string;
    size: number;
    mimeType: string;
    type: string;
}

export interface QuestionMedia extends MediaFile {
    questionId?: string;
    customId?: string;
}

class MediaService {
    async getAllMedia(params?: {
        page?: number;
        limit?: number;
        search?: string;
        type?: string;
    }): Promise<{ media: MediaFile[]; total: number }> {
        const queryParams = new URLSearchParams();
        if (params?.page) queryParams.append('page', String(params.page));
        if (params?.limit) queryParams.append('limit', String(params.limit));
        if (params?.search) queryParams.append('search', params.search);
        if (params?.type) queryParams.append('type', params.type);
        const query = queryParams.toString();
        return ajax.get(`/api/media${query ? `?${query}` : ''}`);
    }

    // The backend infers the media type (image/document/video/audio) from the
    // file's mime type. Never set Content-Type manually for FormData — the
    // browser must generate the multipart boundary.
    async uploadFile(file: File): Promise<MediaUploadResponse> {
        const formData = new FormData();
        formData.append('file', file);

        return ajax.post('/api/media/upload', formData);
    }

    async deleteFile(mediaId: string): Promise<{ message: string }> {
        return ajax.delete(`/api/media/${mediaId}`);
    }

    async getFileUrl(mediaId: string): Promise<{ url: string }> {
        return ajax.get(`/api/media/${mediaId}/url`);
    }

    async uploadQuestionMedia(questionId: string, file: File, customId?: string): Promise<MediaUploadResponse> {
        const formData = new FormData();
        formData.append('file', file);
        if (questionId) {
            formData.append('questionId', questionId);
        }
        if (customId) {
            formData.append('customId', customId);
        }

        return ajax.post('/api/media/upload', formData);
    }

    async getQuestionMedia(questionId: string): Promise<{ media: QuestionMedia[] }> {
        return ajax.get(`/api/media/questions/${questionId}`);
    }
}

export default new MediaService();
